import { Injectable } from "@angular/core";

export interface DonationTemplate {
  mainText: string;
  userMessage: string;
}

@Injectable({
  providedIn: "root",
})
export class DonationTemplateService {
  /**
   * Gera o template visual para doações.
   */
  buildDonationTemplate(data: any): DonationTemplate {
    const totalFormatted = this.formatBRL(data.amount || 0);

    const username = data.username || "Anônimo";
    const amount = totalFormatted || "R$ 0,00";
    const message = data.message || "";

    return {
      mainText: `${username} doou ${amount}.`,
      userMessage: message,
    };
  }

  /**
   * Template fixo para vendas (compatível com TTS).
   */
  buildSaleTemplate(data: any): DonationTemplate {
    const username = data.username || "Alguém";
    const quantity = data.quantity || 1;
    const product = data.productStreamerName || "produto";

    return {
      mainText: `${username} comprou ${quantity} ${product}`,
      userMessage: "",
    };
  }

  private formatBRL(value: number): string {
    return new Intl.NumberFormat("pt-BR", {
      style: "currency",
      currency: "BRL",
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(value || 0);
  }
}
